"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconCrossExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-cross-extra-small"));
var _DismissButton = _interopRequireDefault(require("../_helpers/DismissButton"));
var _utilityButton = require("../utility-button");
var _react2 = require("@emotion/react");
const MessageBannerDismissButton = _ref => {
  let {
    iconAltText,
    setIsVisible,
    'aria-describedby': ariaDescribedby
  } = _ref;
  return (0, _react2.jsx)(_DismissButton.default, {
    colorScheme: _utilityButton.UtilityButtonColorScheme.ColoredBackground,
    "data-test-component": "MessageBannerDismissButton",
    "aria-describedby": ariaDescribedby,
    icon: (0, _react2.jsx)(_iconCrossExtraSmall.default, {
      title: iconAltText
    }),
    onClick: () => setIsVisible(false)
  });
};
var _default = exports.default = MessageBannerDismissButton;